// This file was automatically generated from appchart.refpanel.problems.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.problems');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.ptProblems');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.problems.documentedAsNone = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8ItemHover problemActive am-highlight more-actions-trigger"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p>');
  el8.template.ptdata.ptProblems.documentedAsNoneSummary(null, output);
  output.append('</p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.problems.notDocumented = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p></p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.problems.activeProblemList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var pList5625 = opt_data.actives;
  var pListLen5625 = pList5625.length;
  for (var pIndex5625 = 0; pIndex5625 < pListLen5625; pIndex5625++) {
    var pData5625 = pList5625[pIndex5625];
    el8.template.appchart.refpanel.problems.problem(soy.$$augmentData(pData5625, {hccScoringEnabled: opt_data.hccScoringEnabled, showDualCodingDisabled: opt_data.showDualCodingDisabled}), output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.problems.otherProblemList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var pList5631 = opt_data.controlleds;
  var pListLen5631 = pList5631.length;
  for (var pIndex5631 = 0; pIndex5631 < pListLen5631; pIndex5631++) {
    var pData5631 = pList5631[pIndex5631];
    el8.template.appchart.refpanel.problems.problem(soy.$$augmentData(pData5631, {hccScoringEnabled: opt_data.hccScoringEnabled, showDualCodingDisabled: opt_data.showDualCodingDisabled}), output);
  }
  var pList5636 = opt_data.resolveds;
  var pListLen5636 = pList5636.length;
  for (var pIndex5636 = 0; pIndex5636 < pListLen5636; pIndex5636++) {
    var pData5636 = pList5636[pIndex5636];
    el8.template.appchart.refpanel.problems.problem(soy.$$augmentData(pData5636, {hccScoringEnabled: opt_data.hccScoringEnabled, showDualCodingDisabled: opt_data.showDualCodingDisabled}), output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.problems.xWalkNotifier = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ProblemListNotifierContent"><div class="w10 el8AlignCenter"><span class="el8FeedItemNewMarker"></span></div><div class="el8Medium notifierDescription">', soy.$$escapeHtml(opt_data.needsXWalkCount), ' Problem', (opt_data.needsXWalkCount != 1) ? 's' : '', ' without ICD-10 code(s)</div><div class="w15 notifierActions"><a class="show-needs-xwalk-trigger mr5 ml5">Show</a><a class="dismiss-needs-xwalk-trigger el8RemoveButtonStatic padh5"></a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.problems.problemListNotifierOutdatedDx = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ProblemListNotifierContent"><div class="w10 el8AlignCenter"><span class="el8CodeInvalidDot"></span></div><div class="el8Medium notifierDescription">', soy.$$escapeHtml(opt_data.dxOutdatedCount), ' Problem', (opt_data.dxOutdatedCount != 1) ? 's' : '', ' may contain non-billable ICD code(s)</div><div class="w10 notifierActions"><a class="mr5 ml5 fix-outdated-dx-trigger">Fix</a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.problems.problem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="ptprob_', soy.$$escapeHtml(opt_data.id), '" data-id="', soy.$$escapeHtml(opt_data.id), '" class="el8ItemHover problem', soy.$$escapeHtml(opt_data.status), ' am-highlight more-actions-trigger">', (opt_data.status == 'Active') ? '<span class="problem-sort-handle el8Gripper"></span>' : '', '<div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button></div><div class="el8DateYr">', soy.$$escapeHtml(opt_data.year), '</div><p class="el8ItemWithShortDate"><span class="el8Preserve"><a class="edit-text-trigger" data-id="', soy.$$escapeHtml(opt_data.id), '">');
  el8.template.ptdata.ptProblems.detailedDescriptionWithResolvedStatus(soy.$$augmentData(opt_data, {hccScoringEnabled: opt_data.hccScoringEnabled, showDualCodingDisabled: opt_data.showDualCodingDisabled}), output);
  output.append('</a></span>', (opt_data.details) ? '<span class="details-icon el8DownArrowIcon" style="display:none;"></span><a class="show-details-trigger el8LHSInlineLink" data-id="' + soy.$$escapeHtml(opt_data.id) + '" style="display:none;">Show Synopsis</a><div class="details-section el8ItemWithShortDate relative el8Preserve el8AppColor padv5"><div class="details-field" data-id="' + soy.$$escapeHtml(opt_data.id) + '"></div><a class="hide-details-trigger el8LHSInlineLink el8LHSHideLink" data-id="' + soy.$$escapeHtml(opt_data.id) + '">Hide</a></div>' : '', '</p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.problems.addNewTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LHSButtonContainer"><p>', (opt_data.isNotDocumented) ? '<button type="button" class="el8button document-none-trigger el8ItemButton el8Show ebs-btn ebs-btn-default">No Problems</button><span class="padh10">or</span>' : '', '<button type="button" class="el8button add-problem-trigger el8ItemButton el8Show ebs-btn ebs-btn-default">+ Add Problem</button></p></div>');
  if (!opt_sb) return output.toString();
};
